import script from "./related-zone.vue?vue&type=script&lang=tsx&setup=true"
export * from "./related-zone.vue?vue&type=script&lang=tsx&setup=true"

import "./related-zone.vue?vue&type=style&index=0&id=9c946b5c&lang=scss"

const __exports__ = script;

export default __exports__